<template>
  <section class="qrs-typography">
    <p>current display: {{ display }}</p>
    <div id="mainLanding" v-if="display.includes('mainLanding')">
      <pageHeader>
        <h1 class="qrs-header-xl">Getting to know me</h1>
      </pageHeader>

      <button
        name="Share"
        aria-label="Share questions and answers"
        class="govuk-button govuk-button--action"
        @click="$parent.goTo($Share)"
      >
        Share
        <span class="screen-reader-text">Share questions and answers</span>
      </button>

      <div
        v-for="(item, index) in $parent.jsonData"
        :key="index"
        @click="viewquestionset(item)"
      >
        <!-- <p v-for="i in item.questions" :key="i.index">{{i.title}}</p> -->

        <div class="item__panel">
          <div class="govuk-grid-row">
            <div class="govuk-grid-column-full">
              <div class="item__panel__header">
                <h3 class="mb--0">{{ item.name }}</h3>
                <p class="mt--0">{{ item.description }}</p>
                <span class="hdr__label"
                  >date
                  <i
                    class="fa fa-chevron-right"
                    aria-label="chevron-right"
                    aria-hidden="true"
                  ></i
                ></span>
              </div>
            </div>
          </div>
          <hr class="divider" />
          <div class="govuk-grid-row">
            <div class="item__panel__content mb--0">
              <div class="score govuk-grid-column-one-half">
                <span class="label">Answered</span>
                <p class="mb--0"><strong>0/4</strong></p>
              </div>
            </div>
          </div>
        </div>
        <QuestionSet
          id="questionSet"
          :jsonData="jsonData"
          v-if="display.includes('questionSet')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import QuestionSet from "./questionSet.vue";

const Display_Landing = "mainLanding";
const Display_QuestionSet = "questionSet"

export default {
  name: "mainLanding",

  components: { QuestionSet },

  data() {
    return {
      jsonData: this.$parent.jsonData,
      display: Display_Landing,
    };
  },
  methods: {
    displayClicked(display) {
      this.display = display;
    },
    viewquestionset(q) {
      this.$parent.selectedQuestionSet = q;
      this.displayClicked(Display_QuestionSet);
      this.qidx = 0;
    },
  },
};
</script>